<template>
  <el-table-column
    prop="reference_number"
    sortable="custom"
    label="Hivatkozási szám"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.reference_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'reference_number',
};
</script>
